import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Editor as ClassicEditor } from "ckeditor5-resize-nimbus-build/build/ckeditor";
import React, { useState, useEffect } from "react";
import { MyUploadAdapter } from "../../constructor/umas/MyUploadAdapter";
import { customEditorToolbar, editorImageConfig, editorLinkConfig, listProperties, htmlSupportConfig } from "../../utils/ckEditorUtils";
import { preprocessMathMLForCKEditor, convertFormulaImagesToMathML, DataLatexPlugin } from "../../utils/NimbusMath/ckeditorUtils";
import NimbusPasteStyleCleanupPlugin from "../../constructor/umas/ActividadesUtils/NimbusPasteStyleCleanupPlugin";

function MyCustomUploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    return new MyUploadAdapter(loader);
  };
}

const RichContentInput = ({ value = "", onChange = () => {}, label, error = "", name, disabled = false, placeholder="", styles="" }) => {
  const [processedValue, setProcessedValue] = useState(value);

  // Preprocesar MathML inline a imágenes y normalizar dimensiones
  useEffect(() => {
    const processContent = async () => {
      if (value) {
        const hasMathML = /<math[^>]*>/i.test(value);
        const hasExDimensions = /(?:width|height)=["'][\d.]+ex["']/i.test(value);
        
        if (hasMathML || hasExDimensions) {
          try {
            const processed = await preprocessMathMLForCKEditor(value);
            setProcessedValue(processed);
          } catch (error) {
            console.error('Error preprocesando MathML:', error);
            setProcessedValue(value);
          }
        } else {
          setProcessedValue(value);
        }
      } else {
        setProcessedValue(value);
      }
    };
    processContent();
  }, [value]);

  return (
    <div className={`${styles}`}>
      <p className="font-semibold text-base text-[#0D0C22] truncate mb-2">{label}</p>
      <div className={`editor-wrapper ${error === "" ? "" : "border-2 border-red-400 rounded-[4px]"}`}>
        <CKEditor
          id={name}
          editor={ClassicEditor}
          data={processedValue}
          disabled={disabled}
          config={{
            placeholder: placeholder,
            image: editorImageConfig,
            fontSize: {
              options: [9, 11, 13, "default", 17, 19, 25, 30, 35, 40],
            },
            extraPlugins: [MyCustomUploadAdapterPlugin, DataLatexPlugin, NimbusPasteStyleCleanupPlugin],
            removePlugins: ["Title"],
            mediaEmbed: { previewsInData: true },
            link: editorLinkConfig,
            toolbar: customEditorToolbar,
            list: listProperties,
            htmlSupport: htmlSupportConfig,
            heading: {
              options: [
                { model: "heading1", view: "h1", title: "Heading 1", class: "ck-heading_heading1" },
                { model: "heading2", view: "h2", title: "Heading 2", class: "ck-heading_heading2" },
                { model: "paragraph", title: "Paragraph", class: "ck-heading_paragraph" },
              ],
            },
          }}
          onChange={(event, editor) => {
            const data = editor.getData();
            // Mantener las imágenes con data-latex/data-mathml durante la edición
            // La conversión a MathML puro se hace al guardar en la base de datos
            let eventRichContentInput = {
              target: {
                name: name,
                value: data,
                type: "text",
              },
              persist: () => {},
            };
            onChange(eventRichContentInput);
          }}
        />
      </div>
      <p className="font-thin text-xs text-red-400">{error}</p>
    </div>
  );
};

export default RichContentInput;
